import { createContext, useContext } from 'react'

import { useActiveForm } from '@/components/form/ActiveSwitch'

const AllocationActiveContext = createContext({})

export const useAllocationActive = () => useContext(AllocationActiveContext)

export const AllocationActiveProvider = ({ item, children }) => {
  const { active, setActive } = useActiveForm(item)
  return <AllocationActiveContext.Provider value={{ active, setActive }}>
    {children}
  </AllocationActiveContext.Provider>
}
